import React from "react";
import { Box } from "@mui/material";

const AppSubscriptionWrapper = ({ children }) => {
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Box sx={{ flex: 1 }}>{children}</Box>
    </Box>
  );
};

export default AppSubscriptionWrapper;
